export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  subcategory: string;
  status: '连载中' | '已完结';
  rating: number;
  description: string;
  totalChapters: number;
  latestChapter: string;
  updateDate: string;
  views: number;
  tags: string[];
  chapters: ComicChapter[];
}

export const categories = [
  { slug: 'hanman', name: '韩漫', icon: 'ri-flag-2-line' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line' },
  { slug: 'guoman', name: '国漫', icon: 'ri-star-line' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '重生之都市仙尊',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20cultivation%20immortal%20male%20protagonist%20with%20flowing%20robes%20in%20modern%20city%20background%2C%20dynamic%20pose%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20dramatic%20lighting%20from%20above%2C%20detailed%20illustration%20with%20clean%20lines%2C%20manga%20cover%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'guoman',
    subcategory: '奇幻',
    status: '连载中',
    rating: 4.8,
    description: '一代仙尊重生回到都市少年时代，带着前世的记忆和修为，在这个全新的世界里，他能否再登巅峰？面对曾经的遗憾与错过，他将如何改写命运？都市修仙，热血沸腾，不容错过的精彩故事！',
    totalChapters: 356,
    latestChapter: '第356话 九天之上',
    updateDate: '2026-08-04',
    views: 12850000,
    tags: ['修仙', '都市', '重生', '热血'],
    chapters: Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      title: `第${356 - i}话 ${['九天之上', '突破极限', '风云再起', '破而后立', '新的征程'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 4)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 2,
    title: '社内恋爱',
    author: 'KIM Yuna',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20handsome%20male%20CEO%20and%20beautiful%20female%20office%20worker%20standing%20close%20together%2C%20modern%20office%20glass%20building%20background%2C%20soft%20pink%20and%20warm%20beige%20tones%2C%20romantic%20atmosphere%2C%20clean%20illustration%20style%20with%20delicate%20linework&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'hanman',
    subcategory: '恋爱',
    status: '已完结',
    rating: 4.6,
    description: '刚入职场的她，意外发现自己的直属上司竟然是大学时期暗恋过的学长！办公室里的秘密恋情，在同事的目光和公司的规定之间，两人能否守护这份感情？甜蜜又刺激的职场恋爱故事，让你心跳加速！',
    totalChapters: 128,
    latestChapter: '第128话 我们的未来（完结）',
    updateDate: '2026-07-20',
    views: 9860000,
    tags: ['恋爱', '职场', '韩漫', '甜宠'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${128 - i}话 ${['我们的未来（完结）', '告白', '甜蜜约会', '危机来临', '误会解除'][i % 5]}`,
      updateDate: `2026-${String(7 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 3,
    title: '咒术战线',
    author: '山下智久',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20action%20cover%2C%20young%20sorcerer%20with%20dark%20hair%20summoning%20spiritual%20energy%2C%20urban%20fantasy%20setting%20with%20glowing%20cursed%20symbols%2C%20intense%20battle%20pose%2C%20dark%20blue%20and%20vibrant%20purple%20energy%20effects%2C%20dynamic%20manga%20illustration%20style%20with%20speed%20lines&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'riman',
    subcategory: '热血',
    status: '连载中',
    rating: 4.9,
    description: '在一个充满咒术的世界里，少年继承了家族世代相传的咒术之力。面对黑暗势力的侵袭，他必须与伙伴们并肩作战，守护这个世界的和平。超人气热血日漫，战斗场面炸裂，剧情扣人心弦！',
    totalChapters: 289,
    latestChapter: '第289话 最终决战开幕',
    updateDate: '2026-08-03',
    views: 15600000,
    tags: ['热血', '战斗', '日漫', '奇幻'],
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: i + 1,
      title: `第${289 - i}话 ${['最终决战开幕', '觉醒之力', '宿命的对决', '伙伴的信念', '黑暗降临'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 4,
    title: '女帝的后宫',
    author: '琉璃月',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20manhua%20cover%2C%20beautiful%20empress%20in%20elaborate%20traditional%20hanfu%20red%20dress%2C%20imperial%20palace%20background%20with%20golden%20details%2C%20elegant%20and%20powerful%20female%20lead%2C%20rich%20warm%20red%20and%20gold%20tones%2C%20detailed%20ornate%20illustration%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'guoman',
    subcategory: '恋爱',
    status: '连载中',
    rating: 4.7,
    description: '穿越成为一代女帝，后宫佳丽三千，但她只想要一个真心人。当权谋与爱情交织，她将如何在朝堂与后宫之间游刃有余？大气磅礴的古风恋爱故事，画风精美绝伦！',
    totalChapters: 215,
    latestChapter: '第215话 微服私访',
    updateDate: '2026-08-03',
    views: 11200000,
    tags: ['古风', '恋爱', '宫廷', '穿越'],
    chapters: Array.from({ length: 35 }, (_, i) => ({
      id: i + 1,
      title: `第${215 - i}话 ${['微服私访', '朝堂风云', '后宫暗涌', '真心所向', '权谋较量'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 4)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 5,
    title: '剑道独尊',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20manhua%20cover%2C%20swordsman%20in%20white%20robes%20holding%20glowing%20sword%20on%20mountain%20peak%2C%20misty%20clouds%20and%20cranes%20in%20background%2C%20epic%20martial%20arts%20fantasy%20atmosphere%2C%20cool%20silver%20and%20jade%20green%20color%20scheme%2C%20detailed%20ink%20wash%20illustration%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'guoman',
    subcategory: '热血',
    status: '已完结',
    rating: 4.5,
    description: '少年持剑走天涯，以一把锈剑踏上武道巅峰。从默默无闻到剑道独尊，他用实力证明了一切。热血沸腾的武侠修仙之路，每一场战斗都让人热血澎湃！',
    totalChapters: 420,
    latestChapter: '第420话 剑道独尊（大结局）',
    updateDate: '2026-06-15',
    views: 20300000,
    tags: ['武侠', '修仙', '热血', '战斗'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${420 - i}话 ${['剑道独尊（大结局）', '巅峰之战', '剑意通天', '天下第一', '归隐山林'][i % 5]}`,
      updateDate: `2026-${String(6 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 6,
    title: '霸道总裁的契约新娘',
    author: 'LEE Soyeon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20handsome%20cold%20businessman%20in%20black%20suit%20and%20innocent%20bride%20in%20white%20wedding%20dress%2C%20luxury%20mansion%20interior%20background%2C%20dramatic%20tension%20between%20characters%2C%20elegant%20black%20white%20and%20rose%20gold%20palette%2C%20refined%20manhwa%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'hanman',
    subcategory: '恋爱',
    status: '已完结',
    rating: 4.4,
    description: '为了家族企业，她不得不与素未谋面的霸道总裁签订契约婚姻。本以为只是一场交易，却不料在朝夕相处中，两人的心逐渐靠近。经典的契约恋爱故事，甜到让你尖叫！',
    totalChapters: 96,
    latestChapter: '第96话 永远的契约（完结）',
    updateDate: '2026-07-10',
    views: 14300000,
    tags: ['恋爱', '契约', '韩漫', '总裁'],
    chapters: Array.from({ length: 25 }, (_, i) => ({
      id: i + 1,
      title: `第${96 - i}话 ${['永远的契约（完结）', '真心告白', '家族危机', '携手共进', '甜蜜日常'][i % 5]}`,
      updateDate: `2026-${String(7 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 7,
    title: '偷星九月天新传',
    author: '周洪滨',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20action%20adventure%20manhua%20cover%2C%20teenage%20thief%20duo%20male%20and%20female%20in%20stylish%20modern%20outfits%20leaping%20across%20city%20rooftops%20at%20night%2C%20moonlit%20sky%20with%20stars%2C%20dynamic%20movement%20and%20energy%2C%20cool%20purple%20and%20midnight%20blue%20color%20scheme%2C%20sharp%20modern%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'guoman',
    subcategory: '奇幻',
    status: '连载中',
    rating: 4.8,
    description: '经典的偷星故事全新演绎！九月天重出江湖，与新伙伴们踏上更加惊险刺激的冒险之旅。古墓、秘境、超能力，一扇扇未知之门等待开启。新老粉丝都为之疯狂的超人气作品！',
    totalChapters: 178,
    latestChapter: '第178话 秘境之门',
    updateDate: '2026-08-04',
    views: 18900000,
    tags: ['冒险', '奇幻', '超能力', '国漫'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${178 - i}话 ${['秘境之门', '古墓迷踪', '超能觉醒', '暗影来袭', '九天玄境'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 8,
    title: '关于我转生变成史莱姆这档事',
    author: '伏濑',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20isekai%20fantasy%20manga%20cover%2C%20cute%20blue%20slime%20character%20with%20adventurer%20companions%20in%20magical%20forest%2C%20colorful%20fantasy%20world%20setting%2C%20friendly%20and%20adventurous%20vibe%2C%20bright%20green%20and%20sky%20blue%20tones%2C%20light%20novel%20manga%20art%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'riman',
    subcategory: '奇幻',
    status: '连载中',
    rating: 4.9,
    description: '普通上班族意外转生到异世界，竟然变成了一只史莱姆！但不要小看这只史莱姆，它将建立自己的魔物王国，与各种种族结盟，书写一段传奇的异世界冒险故事！',
    totalChapters: 312,
    latestChapter: '第312话 魔王会议',
    updateDate: '2026-08-02',
    views: 22100000,
    tags: ['转生', '异世界', '奇幻', '冒险'],
    chapters: Array.from({ length: 35 }, (_, i) => ({
      id: i + 1,
      title: `第${312 - i}话 ${['魔王会议', '新盟友', '魔国发展', '强敌来袭', '外交谈判'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 4)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 9,
    title: '末日生存手册',
    author: 'PARK Minsoo',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20post%20apocalyptic%20manhwa%20cover%2C%20survivor%20with%20backpack%20and%20weapon%20in%20ruined%20city%20with%20broken%20buildings%2C%20dramatic%20orange%20sunset%20sky%2C%20tense%20survival%20atmosphere%2C%20gritty%20realistic%20illustration%20style%2C%20warm%20dusty%20brown%20and%20amber%20tones&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'hanman',
    subcategory: '悬疑',
    status: '连载中',
    rating: 4.7,
    description: '末日降临，文明崩塌，幸存的人类在废土之上艰难求生。主角凭借一本神秘的《末日生存手册》，在丧尸和变异生物横行的世界里寻找一线生机。紧张刺激的末世生存故事！',
    totalChapters: 203,
    latestChapter: '第203话 安全区陷落',
    updateDate: '2026-08-04',
    views: 16500000,
    tags: ['末世', '生存', '悬疑', '丧尸'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${203 - i}话 ${['安全区陷落', '丧尸潮', '神秘信号', '地下避难所', '绝境求生'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 10,
    title: '搞笑天师',
    author: '任翔',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manhua%20cover%2C%20funny%20taoist%20priest%20with%20exaggerated%20expressions%20holding%20talisman%20paper%2C%20chaotic%20humorous%20scene%20with%20ghosts%20running%20away%2C%20bright%20and%20colorful%20pop%20art%20style%2C%20energetic%20and%20playful%20vibe%2C%20vibrant%20yellow%20and%20red%20color%20palette&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'guoman',
    subcategory: '搞笑',
    status: '连载中',
    rating: 4.6,
    description: '一个半吊子天师和他的迷糊徒弟，在降妖除魔的道路上闹出无数笑话。各种奇葩妖怪、搞笑法术、无厘头剧情，让你笑到肚子疼！解压神作，不开心的时候看一话，保证笑出声！',
    totalChapters: 267,
    latestChapter: '第267话 天师的婚礼',
    updateDate: '2026-08-03',
    views: 9200000,
    tags: ['搞笑', '道士', '日常', '轻松'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${267 - i}话 ${['天师的婚礼', '捉鬼大赛', '奇葩妖怪', '法术失灵', '徒弟闯祸'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 11,
    title: '东京喰种：RE',
    author: '石田翠',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%2C%20masked%20antihero%20with%20red%20glowing%20eye%20in%20dark%20alley%2C%20gothic%20urban%20Tokyo%20night%20scene%2C%20intense%20psychological%20horror%20vibe%2C%20striking%20red%20and%20black%20contrast%20color%20scheme%2C%20detailed%20mature%20manga%20art%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'riman',
    subcategory: '悬疑',
    status: '已完结',
    rating: 4.8,
    description: '在东京的黑暗中，喰种与人类之间的战争从未停止。失去记忆的少年在CCG中觉醒，他究竟是人类还是喰种？黑暗、压抑又引人深思的经典作品续篇，世界观更加宏大！',
    totalChapters: 179,
    latestChapter: '第179话 新的黎明（完结）',
    updateDate: '2026-05-20',
    views: 25600000,
    tags: ['暗黑', '战斗', '悬疑', '经典'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${179 - i}话 ${['新的黎明（完结）', '最终之战', '真相大白', '宿命对决', '黎明之前'][i % 5]}`,
      updateDate: `2026-${String(5 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 12,
    title: '我的女友是九尾狐',
    author: 'CHOI Jieun',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20beautiful%20nine%20tailed%20fox%20spirit%20girl%20with%20fox%20ears%20and%20modern%20boy%20in%20cherry%20blossom%20park%2C%20magical%20sparkles%20and%20petals%20floating%2C%20sweet%20romantic%20atmosphere%2C%20soft%20pink%20and%20cream%20pastel%20tones%2C%20elegant%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'hanman',
    subcategory: '恋爱',
    status: '连载中',
    rating: 4.5,
    description: '普通大学生偶然救下了一只受伤的狐狸，没想到她竟然是修炼千年的九尾狐！从此，人与妖的甜蜜同居生活开始了。搞笑又浪漫的跨种族恋爱故事，画风超美！',
    totalChapters: 145,
    latestChapter: '第145话 狐族长老',
    updateDate: '2026-08-04',
    views: 10700000,
    tags: ['恋爱', '奇幻', '九尾狐', '同居'],
    chapters: Array.from({ length: 25 }, (_, i) => ({
      id: i + 1,
      title: `第${145 - i}话 ${['狐族长老', '灵力暴走', '第一次约会', '妖界来客', '守护之约'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 13,
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20epic%20manhua%20cover%2C%20young%20warrior%20with%20flame%20surrounding%20his%20body%20standing%20on%20cliff%20edge%2C%20ancient%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20powerful%20and%20determined%20expression%2C%20fiery%20orange%20and%20deep%20crimson%20tones%2C%20grand%20epic%20illustration&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    category: 'guoman',
    subcategory: '热血',
    status: '连载中',
    rating: 4.9,
    description: '斗气大陆，强者为尊！少年萧炎从天才沦为废柴，却凭借一枚戒指中的神秘灵魂重新崛起。炼药、斗技、异火，一路披荆斩棘，誓要登上斗气巅峰！国漫天花板级别的作品！',
    totalChapters: 512,
    latestChapter: '第512话 丹塔传承',
    updateDate: '2026-08-04',
    views: 35200000,
    tags: ['玄幻', '修仙', '热血', '炼药'],
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: i + 1,
      title: `第${512 - i}话 ${['丹塔传承', '异火融合', '中州风云', '魂殿之战', '远古遗迹'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 4)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 14,
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20spy%20comedy%20manga%20cover%2C%20elegant%20spy%20father%20in%20suit%20with%20assassin%20wife%20and%20telepath%20daughter%20posing%20as%20perfect%20family%2C%20retro%20European%20city%20background%2C%20stylish%20and%20charming%20vibe%2C%20warm%20beige%20and%20burgundy%20tones%2C%20clean%20modern%20manga%20art&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    category: 'riman',
    subcategory: '搞笑',
    status: '连载中',
    rating: 4.9,
    description: '为了执行任务，顶尖间谍不得不组建一个临时家庭。然而他不知道，妻子是职业杀手，女儿是超能力者！这个各怀秘密的家庭，在日常与任务中上演了一幕幕爆笑又温馨的故事！',
    totalChapters: 198,
    latestChapter: '第198话 家庭旅行',
    updateDate: '2026-08-03',
    views: 28900000,
    tags: ['搞笑', '家庭', '间谍', '温馨'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${198 - i}话 ${['家庭旅行', '校园活动', '任务危机', '邻居的秘密', '温馨日常'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 15,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20manhua%20cover%2C%20beautiful%20fox%20spirit%20matchmaker%20girl%20in%20traditional%20red%20hanfu%20with%20flowing%20sleeves%2C%20ancient%20Chinese%20village%20with%20lanterns%2C%20romantic%20and%20mystical%20atmosphere%2C%20warm%20red%20and%20golden%20ambient%20lighting%2C%20elegant%20watercolor%20ink%20illustration%20style&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    category: 'guoman',
    subcategory: '恋爱',
    status: '连载中',
    rating: 4.8,
    description: '在人妖共存的世界里，狐妖小红娘以红线续缘，帮助转世的情侣再续前缘。一段段跨越生死的爱恋，一个个感人至深的故事。国漫恋爱天花板，让你笑中带泪！',
    totalChapters: 388,
    latestChapter: '第388话 千年之约',
    updateDate: '2026-08-04',
    views: 31000000,
    tags: ['恋爱', '古风', '妖怪', '催泪'],
    chapters: Array.from({ length: 35 }, (_, i) => ({
      id: i + 1,
      title: `第${388 - i}话 ${['千年之约', '红线牵缘', '前世今生', '涂山之战', '月红篇'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 4)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 16,
    title: '进击的巨人最终季',
    author: '谏山创',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20action%20manga%20cover%2C%20titan%20shifter%20facing%20colossal%20titan%20in%20devastated%20cityscape%2C%20epic%20scale%20battle%20with%20smoke%20and%20debris%2C%20intense%20and%20dramatic%20wartime%20atmosphere%2C%20dark%20brown%20and%20steel%20gray%20color%20palette%2C%20cinematic%20manga%20illustration&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    category: 'riman',
    subcategory: '热血',
    status: '已完结',
    rating: 4.7,
    description: '巨人的真相终于揭晓，世界之外的敌人浮出水面。为了自由和生存，艾伦和他的伙伴们必须做出最后的抉择。震撼世界的史诗级完结篇章，战争与和平的终极思考！',
    totalChapters: 139,
    latestChapter: '第139话 朝着山丘上的那棵树（完结）',
    updateDate: '2026-04-10',
    views: 41000000,
    tags: ['战斗', '黑暗', '史诗', '经典'],
    chapters: Array.from({ length: 25 }, (_, i) => ({
      id: i + 1,
      title: `第${139 - i}话 ${['朝着山丘上的那棵树（完结）', '终末之战', '始祖之力', '自由之翼', '最后的调查兵团'][i % 5]}`,
      updateDate: `2026-${String(4 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 17,
    title: '全知读者视角',
    author: 'sing N song',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20action%20manhwa%20cover%2C%20ordinary%20office%20worker%20transforming%20into%20hero%20in%20apocalyptic%20Seoul%20with%20monsters%2C%20constellation%20system%20interface%20overlay%2C%20tense%20survival%20game%20atmosphere%2C%20cool%20teal%20and%20navy%20blue%20color%20scheme%2C%20modern%20webtoon%20illustration%20style&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    category: 'hanman',
    subcategory: '奇幻',
    status: '连载中',
    rating: 4.9,
    description: '作为唯一读完那部末日小说的人，当小说中的世界变成现实，他成了唯一知道剧情走向的人。凭借着对故事的了解，他能否在这个残酷的星座系统中生存下来？',
    totalChapters: 245,
    latestChapter: '第245话 星座之战',
    updateDate: '2026-08-04',
    views: 27500000,
    tags: ['生存', '系统', '奇幻', '智斗'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${245 - i}话 ${['星座之战', '场景崩塌', '新同伴', '魔王降临', '星流之力'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 18,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20action%20manhua%20cover%2C%20young%20man%20with%20glowing%20qi%20energy%20in%20modern%20Chinese%20city%20street%2C%20martial%20arts%20and%20supernatural%20elements%20merged%2C%20cool%20and%20mysterious%20vibe%2C%20deep%20green%20and%20earthy%20brown%20color%20palette%2C%20detailed%20contemporary%20illustration%20style&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    category: 'guoman',
    subcategory: '热血',
    status: '连载中',
    rating: 4.8,
    description: '普通大学生张楚岚因爷爷的坟墓被盗，卷入了一个隐藏在普通人世界之下的异人世界。炁、八奇技、甲申之乱，一层层谜团等待揭开。国漫经典中的经典！',
    totalChapters: 645,
    latestChapter: '第645话 八奇技之谜',
    updateDate: '2026-08-04',
    views: 38500000,
    tags: ['异能', '战斗', '悬疑', '经典'],
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: i + 1,
      title: `第${645 - i}话 ${['八奇技之谜', '罗天大醮', '碧游村篇', '唐门之行', '纳森岛篇'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 4)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 19,
    title: '鬼灭之刃：无限城篇',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20manga%20cover%2C%20young%20swordsman%20with%20nichirin%20blade%20using%20water%20breathing%20technique%20against%20demon%2C%20traditional%20Japanese%20aesthetic%20with%20floating%20effects%2C%20intense%20action%20and%20elegant%20movement%2C%20deep%20indigo%20and%20crimson%20color%20scheme%2C%20beautiful%20Japanese%20woodblock%20inspired%20art&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    category: 'riman',
    subcategory: '热血',
    status: '连载中',
    rating: 4.9,
    description: '无限城篇正式开启！炭治郎与鬼杀队的柱们深入无惨的无限城，展开最终决战。每一场战斗都是生死对决，每一个牺牲都让人泪目。日漫巅峰之作的最强篇章！',
    totalChapters: 98,
    latestChapter: '第98话 缘一零式',
    updateDate: '2026-08-04',
    views: 33500000,
    tags: ['战斗', '热血', '日漫', '经典'],
    chapters: Array.from({ length: 25 }, (_, i) => ({
      id: i + 1,
      title: `第${98 - i}话 ${['缘一零式', '上弦之战', '柱之觉醒', '斑纹之力', '无限城突入'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
  {
    id: 20,
    title: '神医嫡女',
    author: '杨十六',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20medical%20romance%20manhua%20cover%2C%20beautiful%20female%20doctor%20in%20elegant%20ancient%20Chinese%20dress%20holding%20acupuncture%20needles%2C%20imperial%20palace%20garden%20with%20peony%20flowers%2C%20intelligent%20and%20graceful%20atmosphere%2C%20soft%20pink%20and%20jade%20green%20color%20palette%2C%20delicate%20feminine%20illustration%20style&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    category: 'guoman',
    subcategory: '恋爱',
    status: '连载中',
    rating: 4.6,
    description: '现代医学博士穿越到古代，成为相府不受宠的嫡女。凭借一手出神入化的医术，她步步为营，不仅扭转了自己的命运，还收获了意想不到的爱情。古风医学恋爱爽文！',
    totalChapters: 334,
    latestChapter: '第334话 太医院首座',
    updateDate: '2026-08-03',
    views: 13500000,
    tags: ['古风', '医学', '恋爱', '穿越'],
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: i + 1,
      title: `第${334 - i}话 ${['太医院首座', '疫病防治', '宫廷斗争', '医者仁心', '边疆行医'][i % 5]}`,
      updateDate: `2026-${String(8 - Math.floor(i / 3)).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
  },
];

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.category === slug);
}

export function getFeaturedComics(): Comic[] {
  return comics.filter((c) => c.rating >= 4.8);
}

export function getLatestUpdates(): Comic[] {
  return [...comics].sort((a, b) => b.updateDate.localeCompare(a.updateDate));
}

export function getHotComics(): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views);
}

export function getRelatedComics(comic: Comic, count: number = 6): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && (c.category === comic.category || c.subcategory === comic.subcategory))
    .slice(0, count);
}